import React, { useEffect, useState } from "react";
import "./TooltipPanel.scss";
import { createUseStyles } from "react-jss";

const TooltipPanel = ({ hoverInfo }) => {
  const { color, coordinate, object, picked, x, y } = hoverInfo;

  // console.log("~~~~~~~~~~~~~~~~~~~~~ hoverInfo", hoverInfo);

  const [tltpWidth, setTltpWidth] = useState(null);
  const [tltpHeight, setTltpHeight] = useState(null);
  const [posX, setPosX] = useState(null);
  const [posY, setPosY] = useState(null);

  /* * Styles for TooltipPanel * */
  const useStyles = createUseStyles({
    tooltipStyleAddon: {
      // left: parseInt(x) - (tltpWidth / 2),
      // top: parseInt(y) - (tltpHeight / 2),
    },
  });
  const classes = useStyles();
  /** *************************** */

  const hoverDetails = {
    type: object.type === "Feature" ? "District" : "Store",
    name: object.properties ? object.properties.ENAME : object.data[1],
  };

  useEffect(() => {
    const _elm = document.querySelector("#tltpPnl");
    const _tooltipWidth = _elm ? _elm.offsetWidth : 0;
    const _tooltipHeight = _elm ? _elm.offsetHeight : 0;
    const _posX = parseInt(x);
    const _posY = parseInt(y) - tltpHeight - 6;
    setTltpWidth(_tooltipWidth);
    setTltpHeight(_tooltipHeight);
    setPosX(_posX);
    setPosY(_posY);
  }, [x, y]);

  if (posX !== null)
    return (
      <div
        id="tltpPnl"
        className={`tooltipPanel ${classes.tooltipStyleAddon}`}
        style={{ left: posX, top: posY, opacity: picked ? 1 : 0 }}
      >
        <div className="hoverType">{hoverDetails.type}</div>
        <div className="hoverName">{hoverDetails.name}</div>
      </div>
    );
  else return null;
};

export default TooltipPanel;
